// Pagina contaratos

import React from 'react';
import ContractList from '../components/ContractList';
import ContractDetails from '../components/ContractDetails';


export default function Contracts() {
  const [selectedContract, setSelectedContract] = React.useState(null);

  return (
    <section>
      {selectedContract ? (
        <ContractDetails
          contract={selectedContract}
          onBack={() => setSelectedContract(null)}
        />
      ) : (
        <ContractList onSelect={setSelectedContract} />
      )}
    </section>
  );
}
